import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Log } from 'src/app/_models/log';
import { DataResponse } from 'src/app/_classes/data-respone';
import { map } from 'rxjs/operators';
import { PedidoDeCompra } from 'src/app/_models/pedido-de-compra';
import { EmpresaECentroDestino } from 'src/app/_models/empresa-e-centro-destino';
import { EtiquetaMascarello } from 'src/app/_models/etiqueta-mascarello';
import { RegistrarEtiquetaMascarelloDTO } from 'src/app/_models/registar-etiqueta-mascarello-dto';

@Injectable({
    providedIn: 'root'
})
export class EtiquetasMascarelloService {

    constructor(private httpClient: HttpClient) { }

    registrarArquivoXMLMascarello(arquivoXML: HTMLInputElement): Observable<Response> {

        let arquivoXMLDto = new FormData();

        arquivoXMLDto.append('nomeArquivo', arquivoXML.files[0].name);
        arquivoXMLDto.append('ArquivoXML', arquivoXML.files[0]);

        return this.httpClient.post<DataResponse<any>>(`${environment.apiUrl}/etiquetas-mascarello/registrar-arquivo-xml-mascarello/`, arquivoXMLDto)
            .pipe(map(response => response ? response.data : null));
    }

    getPedidosDeCompraDisponiveis(numRegistros: number, pedidoCompra: string, itemPedidoDeCompra: string): Observable<PedidoDeCompra[]> {
        return this.httpClient.get<PedidoDeCompra[]>(`${environment.apiUrl}/etiquetas-mascarello/get-pedidos-de-compra-disponiveis?numRegistros=${numRegistros}&pedidoCompra=${pedidoCompra}&itemPedidoDeCompra=${itemPedidoDeCompra}`);
    }

    getEmpresasECentrosDestino(): Observable<EmpresaECentroDestino[]> {
        return this.httpClient.get<EmpresaECentroDestino[]>(`${environment.apiUrl}/etiquetas-mascarello/get-empresas-e-centros-destino`);
    }

    registrarEtiqueta(registrarEtiquetaMascarelloDTO: RegistrarEtiquetaMascarelloDTO): Observable<RegistrarEtiquetaMascarelloDTO> {
        return this.httpClient.post<RegistrarEtiquetaMascarelloDTO>(`${environment.apiUrl}/etiquetas-mascarello/registrar-etiqueta`, registrarEtiquetaMascarelloDTO);
    }

    getEtiquetasPorXMLBodyMascarelloId(xmlBodyMascarelloId: string): Observable<EtiquetaMascarello[]> {
        return this.httpClient.get<EtiquetaMascarello[]>(`${environment.apiUrl}/etiquetas-mascarello/get-etiquetas-por-xmlbodymascarelloid/${xmlBodyMascarelloId}`);
    }
}
